import { ref, watch, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrowersList() {
    const client = ref(JSON.parse(localStorage.getItem('userData')).client)

    const toast = useToast()
    const records = ref(null)

    const tempColumns = ref(null)

    // Table Handler
    if(client.value.type === 0){
        tempColumns.value = [
            { key: 'name', label: 'Grower Name', sortable: true, searchable: true },
            { key: 'gender', sortable: true, searchable: true },
            { key: 'registrationNumber', label: 'Reg #', sortable: true, searchable: true },
            { key: 'type', sortable: true, searchable: true },
            { key: 'society', sortable: true, searchable: true },
            { key: 'sector', sortable: true, searchable: true },
            { key: 'club', sortable: true, searchable: true },
            { key: 'hectares'},
            { key: 'labors'},
            { key: 'motherBeds', label: 'M/Beds'},
            { key: 'resetBeds', label: 'R/Beds'},
            'actions',
        ]
    }
    else{
        tempColumns.value = [
            { key: 'name', label: 'Grower Name', sortable: true, searchable: true },
            { key: 'gender', sortable: true, searchable: true },
            { key: 'registrationNumber', label: 'Reg #', sortable: true, searchable: true },
            { key: 'type', sortable: true, searchable: true },
            { key: 'address', label: 'address', sortable: true, searchable: true },
            { key: 'club', sortable: true, searchable: true },
            { key: 'targets', label: 'Estmated KGs', sortable: false, searchable: false },
            'actions',
        ]
    }

    const columns = tempColumns.value

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('updated_at')
    const isSortDirDesc = ref(true)
    const locationFilter = ref(null)
    const locationType = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([locationFilter, currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-grower/list', {
            location_id: locationFilter.value,
            query: searchQuery.value,
            per_page: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { growers, meta } = response.data

            meta.value = meta

            callback(growers)
            totalRecords.value = meta.value.total
            from.value = meta.value.from
            to.value = meta.value.to
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching seasons list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = status => {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
    
        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,
    
        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
        locationFilter,
    }
}
